import { render, staticRenderFns } from "./storage-register.vue?vue&type=template&id=29cfb846&"
import script from "./storage-register.vue?vue&type=script&lang=js&"
export * from "./storage-register.vue?vue&type=script&lang=js&"
import style0 from "./storage-register.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports